<template>
  <div class="main-wrapper" :class="{ 'premium-plan': !isFree, 'free-plan': isFree }">
    <div class="top-elements">
      <h6>
        {{ typeOfPlan }}
      </h6>
      <div class="subtitle">
        {{ isFree ? $t('forsmallteams') : $t('forbiggerteams') }}
      </div>
      <div class="price">
        {{ pricePerMember }}
      </div>
      <div>
        {{ stringForToggle }}
      </div>
    </div>
    <button v-if="!isFree" class="clavo-button primary" @click="$emit('button-clicked')">
      {{ $t('upgrade') }}
    </button>

    <button v-else class="clavo-button clavo-button-inactive">
      {{ $t('freePlanToGetStarted') }}
    </button>
    <div class="feature-text">
      {{ $t('includes') }}
    </div>
    <ul class="features-list">
      <!-- <li
        v-if="!isFree"
        class="include-free"
      >
        {{ $t('includesEverythingInFree') + alsoIncludeComputed }}
      </li> -->
      <li v-for="item in contentOfThePlan" :key="item">
        {{ item }}
      </li>
    </ul>
    <div v-if="!isFree" class="footer-vat">
      {{ $t('excludingvat') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanComponent',
  props: {
    contentOfThePlan: Array,
    pricePerMember: String,
    isMonthly: Boolean,
    isFree: Boolean,
    typeOfPlan: String,
    alsoInclude: String,
  },
  data() {
    return {}
  },
  computed: {
    alsoIncludeComputed() {
      if (this.alsoInclude === undefined) return ''
      else return ' and ' + this.alsoInclude
    },
    stringForToggle() {
      if (this.isFree) return this.$t('upto5persons')
      else if (this.isMonthly) return this.$t('perPersonPerMonthWhenBilledMonthly')
      else return this.$t('perPersonPerMonthWhenBilledYearly')
    },
  },
  created() {},
}
</script>

<style scoped lang="scss">
h6 {
  font-family: $bold;
  font-size: 20px;
  line-height: 36px;
}
.main-wrapper {
  width: 380px;
  padding: 34px 50px 60px 50px;
  position: relative;
  @include respond-below(xs) {
    width: 100%;
    padding-left: 34px;
    padding-right: 34px;
  }

  .top-elements {
    width: 100%;
    height: 240px;
  }
  ul {
    list-style-image: url('../../assets/ico/feature-checkmark.svg');
    padding: 0 0 0 36px;
    margin: 0;
    position: relative;
    li {
      list-style-position: outside;
      line-height: 24px;
      padding: 6px 0 6px 10px;
    }
    .include-free:before {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 36px;
      top: 0;
      left: 0;
      background-color: rgba($lime, 0.1);
      border-radius: 4px;
    }
  }

  .subtitle {
    font-size: 16px;
    line-height: 24px;
    @include font-rule('averta-regular');
  }
  .price {
    @include font-rule('averta-bold');
    font-size: 48px;
    line-height: 54px;
    margin-top: 36px;
    margin-bottom: 15px;
  }

  .clavo-button {
    &.primary {
      width: 100%;
      height: 50px;
    }
  }

  .clavo-button-inactive {
    width: 100%;
    height: 50px;
  }

  .feature-text {
    @include label;
    margin-top: 36px;
    margin-bottom: 7px;
  }
  .premium-plan {
    box-sizing: border-box;
    border: 1px solid #4b61ee;
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.15), 18px 24px 0 0 #f5f6f8;
  }
  .free-plan {
    border-radius: 13px;
    background-color: #f4f7fb;
  }
  .footer-vat {
    align-self: end;
    // position: absolute;
    bottom: 51px;
    padding-top: 24px;
    color: $bluebell;
    font-size: 13px;
    @include respond-below(md) {
      position: relative;
      bottom: 0px;
      margin-bottom: -12px;
    }
  }
}
</style>
